<template>
  <BasePageContainer class="admin pt-4">
    <page-header
      has-back>
      カテゴリー管理
    </page-header>
    <div class="page__body admin-content pt-5 pb-10">
      <ul
        class="list-unstyled mt-3">
        <category-list-item
          v-for="category in categories"
          :key="category.id"
          :category="category">
          <div class="category__actions">
            <button
              class="category__btn btn--circle"
              @click="onClickEdit(category.id)">
              <span class="category__btn-icon material-icons">
                edit
              </span>
            </button>
            <button
              class="category__btn btn--circle ml-2"
              data-testid="delete-category-button"
              @click="onClickDelete(category.id)">
              <span class="category__btn-icon material-icons">
                delete
              </span>
            </button>
          </div>
        </category-list-item>
      </ul>
      <div class="admin__add text-right">
        <router-link to="/admin/categories/add/">
          <button class="admin__add-btn btn--circle-l btn-l-blue">
            <span class="admin__add-icon material-icons">
              add
            </span>
          </button>
        </router-link>
      </div>
    </div>
  </BasePageContainer>
</template>

<script>
// @ts-check
import CategoryListItem from '@/components/view/CategoryListItem.vue'
import PageHeader from '@/components/parts/PageHeader.vue'

export default {
  components: {
    PageHeader,
    CategoryListItem
  },
  data() {
    return {
      categories: [],
    }
  },
  async created() {
    await this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      this.$store.commit('startLoading')
      await this.$axios.get('/events/categories/', { params: { ordering: 'sort_order' } })
        .then((res) => {
          this.categories = res.data.results
        })
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
    
      this.$store.commit('finishLoading')
    },
    onClickEdit(id) {
      this.$router.push(`/admin/categories/${id}/edit`)
    },
    async onClickDelete(id) {
      const category = this.categories.find(e=>e.id===id)
      if (!window.confirm(`カテゴリー「${category.name}」を削除します。このカテゴリに作成されたすべての予定も削除されます。よろしいですか？`)) return

      this.$store.commit('startLoading')
      await this.$axios.delete(`/events/categories/${category.id}/`)
        .then(()=>{
          this.$store.commit('notify/set', {message: 'カテゴリーを削除しました。'})
        })
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          this.$store.commit('finishLoading')
          return
        })
      await this.fetchCategories()
      this.$store.commit('finishLoading')

    }
  }
}
</script>

<style lang="scss" scoped>
.admin {
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  &__add {
    right: 16px;
    position: fixed;
    bottom: 0px;
    padding-bottom: calc(80px + constant(safe-area-inset-bottom));
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }
  &__add-btn {
    box-shadow: 1px 2px 6px $grey05;
  }
  &__add-icon {
    //ボタン
    font-size: 30px;
    line-height: 54px;
    width: 30px;
  }
}
.admin-head {
  background-color: $l-blue;
  @media screen and (min-width: 992px) {
    right: 0;
    left: 120px;
  }
  &__back {
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading {
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}

.admin-categories{
  &__icon{
    vertical-align: middle;
    display: inline-block;
  }
  &__item{
    position: relative;
    background-color: $white;
    border-radius: 8px;
    font-weight: bold;
  }
  
  &__btn{
    position: relative;
    box-shadow: 1px 2px 6px $grey05;
    padding: 2px;
    line-height: 27px;
    @media screen and (min-width:768px) {
       padding: auto;
       line-height: auto;
    }

  }
  &__btn-icon{
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 20px;
  }
}
</style>
